<div #radioGroupHead class="wiz-component-container" width="100%" height="100%" [ngClass]="{'disabled-class': wizDisabled}"
tabindex="0" (focus)="onFocus($event)" >
  <div class="wiz-component-label" width="100%" *ngIf="wizShowLabel">
    <wiz-label #innerLabel [wizLabel]="wizLabel" [wizTextBehavior]="'truncate'"
    [ngClass]="{'error-class': hasErrors}"></wiz-label><!-- label -->
    <span #innerAsterisk *ngIf="wizMandatory" class='mandatory-class'>*</span><!-- asterisque -->
  </div>
  <!-- contenu pour inclure les layouts et boutons -->
  <wiz-vgroup><ng-content ></ng-content></wiz-vgroup>
  <!-- l'affichage de l'erreur -->
  <ng-container #errorContainer></ng-container>
</div>